import { render, staticRenderFns } from "./orderAccounting.vue?vue&type=template&id=2fd91437&"
import script from "./orderAccounting.vue?vue&type=script&lang=js&"
export * from "./orderAccounting.vue?vue&type=script&lang=js&"
import style0 from "./orderAccounting.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports